import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["x", "y", "width", "height", "transform", "fill"]
const _hoisted_3 = ["y", "width", "height", "transform", "fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'closeIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#000000",
  },
  size: {
    type: Number as PropType<number>,
    default: 17,
  },
  h: {
    type: Number as PropType<number>,
    default: 17,
  },
  x1: {
    type: Number as PropType<number>,
    default: 14.3042,
  },
  y1: {
    type: Number as PropType<number>,
    default: 0.000198364,
  },
  w1: {
    type: Number as PropType<number>,
    default: 2.5286,
  },
  h1: {
    type: Number as PropType<number>,
    default: 20.2288,
  },
  y2: {
    type: Number as PropType<number>,
    default: 1.78799,
  },
  w2: {
    type: Number as PropType<number>,
    default: 2.5286,
  },
  h2: {
    type: Number as PropType<number>,
    default: 20.2288,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle(`max-width: ${__props.size}px; max-height: ${__props.h}px; min-width: ${__props.size}px; min-height: ${__props.h}px; display: flex; align-items: center; cursor: pointer`)
  }, [
    (_openBlock(), _createElementBlock("svg", {
      style: {"width":"100%","height":"100%"},
      viewBox: `0 0 ${__props.size} ${__props.h}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("rect", {
        x: __props.x1,
        y: __props.y1,
        width: __props.w1,
        height: __props.h1,
        transform: `rotate(45 ${__props.x1} ${__props.y1})`,
        fill: __props.color
      }, null, 8, _hoisted_2),
      _createElementVNode("rect", {
        y: __props.y2,
        width: __props.w2,
        height: __props.h2,
        transform: `rotate(-45 0 ${__props.y2})`,
        fill: __props.color
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_1))
  ], 4))
}
}

})